'use-client';
import classnames from 'clsx';
import * as React from 'react';
import type {
  IContainerProps,
  IContainerImperativeActions,
} from '../../../Container.types';
import { ContainerLogic } from '../../shared/ContainerLogic';
import styles from './SandClockArea.scss';

const SandClockArea: React.ForwardRefRenderFunction<
  IContainerImperativeActions,
  IContainerProps
> = (props, ref) => {
  return (
    <ContainerLogic
      {...props}
      ref={ref}
      className={classnames(styles.root, props.className)}
      renderSlot={({ containerChildren }) => (
        <>
          <b className={styles.tl}></b>
          <b className={styles.tr}></b>
          <b className={styles.bl}></b>
          <b className={styles.br}></b>
          {containerChildren}
        </>
      )}
    />
  );
};

export default React.forwardRef(SandClockArea);
